var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { appointmentKindLabels } from 'constants/appointmentKind';
import { appointmentStatus } from 'constants/ehrNoteEnums';
import { defaultPageSizeOptions } from 'constants/table';
import { Info } from 'shared/assets/icons';
import { Coaching } from 'shared/assets/images/Coaching';
import { Box, NoData, NoShowIndicator, Text } from 'shared/components';
import { RiskTableCell, TableCellLink } from 'shared/features/table';
import { formatFullDate, formatFullDateTime, getAgeFromFormattedDob, linkToNoteOrPlaceholder, } from 'shared/utils';
import { PaginatedTable } from 'src/shared/features/table/components/PaginatedTable';
import { usePagedSignedNotes } from 'src/shared/hooks/';
import { useMemo } from 'react';
export function PagedSigned() {
    var pagedCols = useMemo(function () { return [
        {
            id: 'last_name',
            header: 'Name',
            accessorFn: function (row) { var _a; return (_a = row === null || row === void 0 ? void 0 : row.member) === null || _a === void 0 ? void 0 : _a.last_name; },
            cell: function (_a) {
                var row = _a.row;
                var member = ((row === null || row === void 0 ? void 0 : row.original) || {}).member;
                var age = getAgeFromFormattedDob(member === null || member === void 0 ? void 0 : member.date_of_birth);
                return (_jsx(Box, __assign({ m: 2, maxWidth: "260px" }, { children: _jsxs(TableCellLink, __assign({ "data-testid": member === null || member === void 0 ? void 0 : member.first_name, to: "/client/".concat(member === null || member === void 0 ? void 0 : member.id, "/demographics"), subtitle: "".concat(member === null || member === void 0 ? void 0 : member.date_of_birth, " (").concat(age, " yo)") }, { children: [member === null || member === void 0 ? void 0 : member.first_name, " ", member === null || member === void 0 ? void 0 : member.last_name, ' '] })) })));
            },
        },
        {
            header: 'Note status',
            id: 'signed_at',
            accessorFn: function (row) { var _a; return (_a = row.note) === null || _a === void 0 ? void 0 : _a.signedAt; },
            cell: function (_a) {
                var row = _a.row;
                var note = row.original.note;
                var noteStatus = (note === null || note === void 0 ? void 0 : note.signedAt) ? 'Signed' : (note === null || note === void 0 ? void 0 : note.updatedAt) ? 'Draft' : 'Not started';
                return (_jsx(Box, __assign({ m: 2 }, { children: _jsx(TableCellLink, __assign({ "data-testid": "signedNoteStatus", to: linkToNoteOrPlaceholder(row.original), subtitle: formatFullDate((note === null || note === void 0 ? void 0 : note.signedAt) || '', true) }, { children: noteStatus })) })));
            },
        },
        {
            id: 'start',
            header: 'Date/Time',
            accessorFn: function (row) { return row === null || row === void 0 ? void 0 : row.date; },
            cell: function (_a) {
                var _b, _c, _d, _e, _f, _g, _h;
                var row = _a.row;
                var status = (_d = (_c = (_b = row.original) === null || _b === void 0 ? void 0 : _b.note) === null || _c === void 0 ? void 0 : _c.sessionInfo) === null || _d === void 0 ? void 0 : _d.status;
                return (_jsx(Box, __assign({ m: 2 }, { children: _jsxs(TableCellLink, __assign({ "data-testid": "appointmentDate", to: linkToNoteOrPlaceholder(row.original), subtitle: ((_e = row.original) === null || _e === void 0 ? void 0 : _e.appointment)
                            ? appointmentKindLabels[(_g = (_f = row.original) === null || _f === void 0 ? void 0 : _f.appointment) === null || _g === void 0 ? void 0 : _g.kind]
                            : 'Unscheduled Interaction' }, { children: [status && status !== appointmentStatus.completed && (_jsx(NoShowIndicator, { showStatus: status })), formatFullDateTime((_h = row === null || row === void 0 ? void 0 : row.original) === null || _h === void 0 ? void 0 : _h.date, true)] })) })));
            },
        },
        {
            header: 'Provider reported',
            headerIcon: Info,
            headerTooltipTitle: 'Risk',
            headerTooltipDescription: 'Risk level is reported by you and is based on the highest risk level from your last appointment, whether it’s self-harm or harm to others.',
            accessor: '',
            id: 'risk',
            cell: function (_a) {
                var row = _a.row;
                var _b = row.original, note = _b.note, riskConcerns = _b.riskConcerns;
                var riskForHarmToSelf = riskConcerns.riskForHarmToSelf, riskForHarmToOthers = riskConcerns.riskForHarmToOthers;
                return (_jsx(RiskTableCell, __assign({ riskToSelf: riskForHarmToSelf || undefined, riskToOthers: riskForHarmToOthers || undefined }, { children: riskConcerns.date !== (note === null || note === void 0 ? void 0 : note.signedAt) && (_jsx(Text, __assign({ mt: 2, size: 'small' }, { children: formatFullDate(riskConcerns.date || '') }))) })));
            },
        },
    ]; }, []);
    return (_jsx(_Fragment, { children: _jsx(PaginatedTable, { columns: pagedCols, query: usePagedSignedNotes, pageSizeOptions: defaultPageSizeOptions, preservedTableId: "pagedSigned", noData: _jsx(NoData, { title: "You do not have any signed notes yet.", icon: _jsx(Coaching, {}) }) }) }));
}
